module.exports = __webpack_public_path__ + "img/4D.3192c5a9.png";